import { GetMe_me_organizations } from '../../../models/legacy-graphql';

export const getNumberOfWorkspaces = (organizations: GetMe_me_organizations[] | undefined): number => {
  let workspace_count = 0;

  organizations?.forEach(organization => {
    workspace_count += organization.workspaces.length;
  });

  return workspace_count;
};
